import styled from 'styled-components';
import { Banner as EncoreBanner } from '@spotify-internal/encore-web';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { log } from '../lib/logger';
import TextDir from '../lib/TextDir';
const StyledBanner = styled(EncoreBanner) `
  position: absolute;
  ${props => (props.isLink ? 'cursor: pointer;' : '')}
  top: 95px;
  left: 50%;
  translate: -50%;
  width: 24rem;
  border-radius: 4px;
  z-index: 2;

  @media screen and (max-width: 768px) {
    width: 95%;
  }
`;
export const ErrorBanner = ({ state, message, onCloseClick, }) => {
    const { t, i18n } = useTranslation();
    switch (state) {
        case 'need-close':
            return (React.createElement(StyledBanner, { "data-testid": "error-banner-close-message", colorSet: "negative", onClick: onCloseClick, isLink: true, dir: i18n.dir() },
                React.createElement(TextDir, { locale: i18n.language }, t('SOMETHING_WENT_WRONG_CLICK_TO_CLOSE_TEXT'))));
        case 'need-refresh':
            return (React.createElement(StyledBanner, { "data-testid": "error-banner-refresh-message", colorSet: "negative", dir: i18n.dir() },
                React.createElement(TextDir, { locale: i18n.language }, message !== null && message !== void 0 ? message : t('SOMETHING_WENT_WRONG_REFRESH_TEXT'))));
        default:
            log.error('unexpected ErrorBanner state prop', state);
            return null;
    }
};
